"use client";
import { useRef, useState } from "react";
import { Accordion, AccordionHeader, AccordionBody } from "@material-tailwind/react";
import { useGenerator } from "@/app/context/GeneratorContext";
import { useGlobalContext } from "@/app/context/store";

export default function NegPromptToggleSet({ translations }: { translations: any }) {
  const { state, setCustomNegative } = useGenerator();
  const [open, setOpen] = useState(0);
  const { user } = useGlobalContext();
  const textAreaRefNegative = useRef(null);

  const handleOpen = (value: any) => {
    setOpen(open === value ? 0 : value);
  };

  const handleTextAreaChangeNegative = (e: any) => {
    const newText = e.target.value;
    setCustomNegative(newText);

    // Now, reset the height to "auto" to shrink it in case the content is reduced
    //@ts-ignore
    textAreaRefNegative.current.style.height = "auto";

    // Then, set it to its scrollHeight
    //@ts-ignore
    textAreaRefNegative.current.style.height = `${textAreaRefNegative.current.scrollHeight}px`;
  };

  // @ts-ignore
  function Icon({ id, open }) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className={`${id === open ? "rotate-180" : ""} h-5 w-5 transition-transform`}
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={2}
      >
        <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
      </svg>
    );
  }

  return (
    <Accordion
      open={open === 1}
      icon={<Icon id={1} open={open} />}
      className="border-t-[0.5px] border-[#3C3C3C] bg-[#2B2D31] px-2 pt-2 md:px-4"
    >
      <AccordionHeader
        onClick={() => handleOpen(1)}
        className={`border-b-0 px-[4px] pb-4 pt-2 text-sm text-white sm:px-0 ${
          open === 1 ? "text-white hover:!text-white" : ""
        }`}
      >
        {translations.negativePrompt}
      </AccordionHeader>
      <AccordionBody className="pb-2 pt-0 font-normal text-white">
        <div className="relative">
          <div className="mx-auto mb-3 whitespace-nowrap text-center font-semibold text-[#FFCC18]">
            {translations.premiumFeature}
          </div>
          <div className="my-2 md:my-4">
            <textarea
              ref={textAreaRefNegative}
              value={state.customNegative}
              onChange={handleTextAreaChangeNegative}
              placeholder={
                user._id === "none" || user.membership?.level !== 1
                  ? translations.placeHolderFour
                  : translations.placeHolderFive
              }
              disabled={user._id === "none" || user.membership?.level !== 1}
              readOnly={user._id === "none" || user.membership?.level !== 1}
              className="auto-height-textarea w-full rounded-md border-[0.5px] border-[#3C3C3C] bg-[#303237] px-4 py-2 text-[16px] focus:border-[#3C3C3C] focus:ring-0"
              rows={1} // Start with one row
              style={{ overflow: "hidden", resize: "none" }} // Prevent scrollbars and user resizing
              maxLength={1000}
            ></textarea>
            {(user._id === "none" || user.membership?.level !== 1) && (
              <div
                className="absolute inset-0 cursor-not-allowed"
                onClick={(e) => e.stopPropagation()} // Prevent interactions beneath
              />
            )}
          </div>
        </div>
      </AccordionBody>
    </Accordion>
  );
}
